module.exports = __webpack_public_path__ + "img/ico-close-dark.6491b2d0.svg";